import { Component, OnInit, ViewChild } from '@angular/core';
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import Swal from 'sweetalert2';
import { FormControl, FormGroup } from '@angular/forms';
import { LoginService } from 'app/services/login/login.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-empresa-riesgo',
  templateUrl: './listado-empresa-riesgo.component.html',
  styleUrls: ['./listado-empresa-riesgo.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
  {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})
export class ListadoEmpresaRiesgoComponent implements OnInit {

  loading:boolean;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['checked', 'RUC', 'Razon_Social','Ubicacion','Sector', 'Ranking'];
  dataSource : any;
  user:any;
  empresas : any = [];
  abrirContactos : boolean = false;
  abrirDetalleReclamo:boolean = false;
  abrirPopUp:boolean = false;
  sectores:any;
  rucEmpFilter = new FormControl('');
  razEmpFilter = new FormControl('');
  filterValues ={
    razonSocial:'',
    ruc:'',
    Sector:''
  }
  dataFiltro :FormGroup;
  dataEnviar : any = {};
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private riesgosService : RiesgoService, private loginService:LoginService, private router:Router) { 
        this.user = JSON.parse(sessionStorage.getItem('UserActive'));
        this.dataFiltro = new FormGroup({
          "Sector":new FormControl(''),
          "Observaciones":new FormControl('')
        });  
    }

  ngOnInit() {
    this.listadoEmpresasRiesgo();    

    this.razEmpFilter.valueChanges.subscribe(
      razonSocial=>{
        this.filterValues.razonSocial=razonSocial;
        this.dataSource.filter=JSON.stringify(this.filterValues);
      }
  )

  this.rucEmpFilter.valueChanges.subscribe(
    ruc=>{
      this.filterValues.ruc=ruc;
      this.dataSource.filter=JSON.stringify(this.filterValues);
    }
)

this.dataFiltro.get('Sector').valueChanges.subscribe(
  Sector => {
    this.filterValues.Sector = Sector;
    this.dataSource.filter = JSON.stringify(this.filterValues);
  }
);
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Razon_Social.toString().toLowerCase().indexOf(searchTerms.razonSocial) !== -1
      && data.Num_Doc_Identificacion.toString().toUpperCase().indexOf(searchTerms.ruc) !== -1
      && data.idSector === (searchTerms.Sector== ''?data.idSector:searchTerms.Sector)      
    }

  }
  
  open(element:any){
    console.log(element);
   }

   BlackList(element,event){
    if (event == null) { return; }
    this.ListaNegra(element, event)  
   }
  listadoEmpresasRiesgo(){
    this.loading=true;
    this.ListarSectores();
    this.riesgosService.FiltrosEmpresaRiesgo().subscribe(
      res =>{
        this.empresas = res['message'];
        this.dataSource = new MatTableDataSource(this.empresas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      }, err =>{
        Swal.fire({
          title:"!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick : true,
          heightAuto: false
        });
        this.loading = false
      }
    )
  }

  ListaNegra(element, event){ 
      this.dataEnviar.Ruc=element.Num_Doc_Identificacion;
      this.dataEnviar.Tipo=0;
      this.dataEnviar.Usuario=this.user.Usuario;
      this.dataEnviar.SectorEconomico=element.idSector;
      this.dataEnviar.RUC_TOP=0
      this.dataEnviar.Estado=0 
      this.dataEnviar.Razon=event;
      Swal.fire({
        title: '¡Espere por favor!',
        text:'Estamos guardado la información.',
        type:'info',
        allowOutsideClick:false,
        heightAuto: false
      });    
      Swal.showLoading();
      this.riesgosService.RegistrarExcepcion(this.dataEnviar)
          .subscribe( resp => {
              Swal.fire({
                title: "¡Éxito!",
                text: 'Se agrego a la lista Negra.',
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              }).then( resp1 => {
                if (resp1.value == true){
                  this.loginService.clickGuard = true;
                  this.router.navigate(['/riesgo/empresa/listaNegra']);
                }
            });
      },(err: HttpErrorResponse)=> {
        Swal.fire({
          title: "Error!",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        })      
      })     
  }

  CerrarContactos(){
    this.abrirContactos = false;
  }

  
  onClick(element:any){    

    this.abrirContactos = true;
    this.riesgosService.contactoEmpresa = element;   
  }

  ListarSectores(){
    this.loading = true;
    this.riesgosService.obtenerSectoresEconomicos().subscribe(
      res=>{
        this.sectores=res;
          this.sectores=this.sectores.filter(est => est.Estado == "A");
        this.loading = false;
      }        
    )      
  }

  AbrirPopUp(element:any){
    this.riesgosService.datos = element;
    this.abrirPopUp = true;
  }

  CerrarPopUp(){
    this.abrirPopUp = false;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
